export default __webpack_public_path__ + "static/media/join.c6da86d3.png";